import React, { Component,useState } from 'react';
import './DyanmicTable.css';
import moment from "moment";

import Modal from './Modal'; // Import the modal
import Comment from '../Comment/Comment';

const RenderRow = (props) => {
    const [showModal, setShowModal] = useState(false); // State to manage modal visibility
    const [showModal2, setShowModal2] = useState(false); // State to manage modal visibility

    const handleExpandClick = () => {
      setShowModal(true); // Show modal on expand button click
    };
    const handleExpandClick2 = () => {
        setShowModal2(true); // Close modal on close button click
      };
    
    const handleCloseModal = () => {
      setShowModal(false); // Close modal on close button click
      setShowModal2(false); // Close modal on close button click
    };
    if (props.customkeys != null && props.customkeys != undefined && props.customkeys.length > 0) {

        return props.customkeys.map((key, index) => {
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'date') {

                let dataformat = localStorage.getItem("DefaultDateFormat");
                let inData = "";
                if (dataformat != null && dataformat != undefined && props.data[key.fieldName] != null) {
                    dataformat = dataformat.replace('dd', 'DD');

                    inData = moment(props.data[key.fieldName]).format(dataformat);
                    return <td key={props.data[key.fieldName]}>{inData == "01-01-0001" ? "" : inData}</td>
                }
                else {
                    return <td key={props.data[key.fieldName]}>{inData}</td>
                }


            }
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'datetime') {

                let dataformat = localStorage.getItem("DefaultDateFormat");
                let inData = "";
                if (dataformat != null && dataformat != undefined && props.data[key.fieldName] != null) {
                    dataformat = dataformat.replace('dd', 'DD');
                    dataformat = dataformat + " HH:mm:ss";
                    inData = moment(props.data[key.fieldName]).format(dataformat);
                    return <td key={props.data[key.fieldName]}>{inData == "01-01-0001" ? "" : inData}</td>
                }
                else {
                    return <td key={props.data[key.fieldName]}>{inData}</td>
                }


            }

            if (key.dataType != null && key.dataType != undefined && key.dataType == 'link') {
                if (props.data[key.fieldName]) {
                    return <td key={props.data[key.fieldName]}><a href={props.data[key.fieldName]} target='_blank'>Download</a></td>
                }
                else {
                    return <td key={props.data[key.fieldName]}></td>
                }



            }
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'text') {

                return <td className='fixedwidth-350' key={index}>


                    <input className='fixedwidth-350' required value={props.data[key.fieldName]}
                        onChange={(event) => { console.log(key); key.handleChange(event, key.fieldName, props.rowIndex) }} />
                </td>

            }
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'dropdown') {

                return <td className='fixedwidth-350' key={index}>

                    <select className='dyanmictable-dropdown'
                        onChange={(event) => { console.log(key); key.handleChange(event, key.fieldName, props.rowIndex) }} >
                        <option id={null} >
                            {"Select Reason"}
                        </option>
                        {key.dropdownData.map((_item, index) =>

                            <option value={_item.id} selected={props.data[key.fieldName] == _item.id} key={`${props.rowIndex}${props._item}`} id={_item.id} >
                                {/* {_item.value} */}
                                {_item.value}
                            </option>

                        )
                        }

                    </select>

                    {/* <input className='fixedwidth-350' required value={props.data[key.fieldName]}
                     onChange={(event)=>{console.log(key); key.handleChange(event,key.fieldName,props.rowIndex)}} /> */}
                </td>

            }

            if (key.dataType != null && key.dataType != undefined && key.dataType == 'link_button') {

                return <td key={props.data[key.fieldName]}>
                    
                     <a href={"#"} onClick={() => props.handleLink_Button_Click(props.data)} >{key.text}</a> 
                    </td>



            }
            
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'link_button_for_empty') {

                return <td key={props.data[key.fieldName]}> 
                {props.data["Comment"] &&
                
                     <a href={"#"} onClick={() => props.handleLink_Button_Click(props.data)} >{key.text}</a> 
            }
            {!props.data["Comment"] &&
                
                <>No Comment</>
       }
            
                    </td>



            }
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'expand_button') {

                return <td key={props.data[key.fieldName]}>
                    
                    {props.data[key.fieldName] &&  props.data["show"] && props.data["show"] == true &&
                        <p><span style={{ textAlign: "left", marginLeft: 20 }}>{props.data[key.fieldName]}</span></p>
                    }
                    {props.data[key.fieldName] && props.data["show"] != true && <a style={{ cursor: "pointer" }} href={"#"} onClick={() => props.handleLink_Button_Click(props.data, props.data["show"])} >{key.text}</a>}
                    {props.data[key.fieldName] &&  props.data["show"] === true && <br />}
                    {props.data[key.fieldName] &&  props.data["show"] === true && <div style={{ textAlign: "right", padding: 10 }} ><a style={{ cursor: "pointer" }} href={"#"} onClick={() => props.handleLink_Button_Click(props.data, props.data["show"])} >Hide</a></div>}
                </td>


            }
            if (key.dataType === 'expand_button2'  ) {
                return (
                  <td key={props.data[key.fieldName]}>
                    {props.data[key.fieldName] && !props.data["show"] && (
                      <a
                        style={{ cursor: 'pointer' }}
                        href={'#'}
                        onClick={handleExpandClick2}
                      >
                        {key.text}
                      </a>
                    )}
        
                    {/* Render modal with content */}
                    {showModal2 && (
                      <Modal show={showModal2} handleClose={handleCloseModal}>
                        <p>{props.data[key.fieldName]}</p> {/* Display content in modal */}
                        
                      </Modal>
                    )}
                  </td>
                );
              }
            if (key.dataType === 'expand_button1'  ) {
                return (
                  <td key={props.data[key.fieldName]}>
                    {props.data[key.fieldName] && !props.data["show"] && (
                      <a
                        style={{ cursor: 'pointer' }}
                        href={'#'}
                        onClick={handleExpandClick}
                      >
                        {key.text}
                      </a>
                    )}
        
                    {/* Render modal with content */}
                    {showModal && (
                      <Modal show={showModal} handleClose={handleCloseModal}>
                        <Comment hideSection={true} moduleCode='Mod_47'  uniqueCode={props.data["BookShipmentCode"]}  /> 
                        
                      </Modal>
                    )}
                  </td>
                );
              }
            if (key.dataType != null && key.dataType != undefined && key.dataType == 'bool') 
            {
                return <td key={props.data[key.fieldName]}>{props.data[key.fieldName]?"True":"False"}</td>
            }
            
            else {

                return <td key={props.data[key.fieldName]}>{props.data[key.fieldName]}</td>


            }


        })
    }
    else {
        return props.keys.map((key, index) => {
            return <td key={props.data[key]}>{props.data[key]}</td>
        })
    }

}

class DyanmicTable extends Component {
    constructor(props) {
        super(props);
    }

    getKeys = function () {
        return Object.keys(this.props.data[0]);
    }

    getHeader = function () {


        var keys = [];
        if (this.props.cols != null && this.props.cols != undefined && this.props.cols.length > 0) {
            let data = [];
            data = this.props.cols;
            data.forEach(element => {
                keys.push({ displayName: element.displayName, dataType: element.dataType })
            });

            //keys = this.props.cols;
        }
        else {
            keys = this.getKeys();
        }

        return keys.map((key, index) => {
            return <th className={key.dataType === 'text' ? 'fixed-header fixedwidth-100' : 'fixed-header'} key={key}>
                {key != null && key != undefined && key.displayName != null || key.displayName != undefined ? key.displayName.toUpperCase() : ""}
            </th>
        })
    }
    getRowsData = function () {

        var items = this.props.data;
        var keys = [];
        if (this.props.cols != null && this.props.cols != undefined && this.props.cols.length > 0) {

            return items.map((row, index) => {
                return <tr key={index}><RenderRow {...this.props.cols}
                    handleLink_Button_Click={this.props.handleLink_Button_Click}
                    rowIndex={index}
                    key={index} data={row} customkeys={this.props.cols}
                /></tr>
            })
        }
        else {
            keys = this.getKeys();
            return items.map((row, index) => {
                return <tr key={index}><RenderRow

                    {...this.props.cols} key={index} data={row} keys={keys}
                /></tr>
            })
        }



    }

    render() {

        let body = <div className={this.props.customClass === undefined ? "container" : this.props.customClass}>
            <table id={this.props.tableCss === undefined ? "grid" : "id"} className={this.props.tableCss}>
                <thead>
                    <tr  >

                        {this.getHeader()}</tr>
                </thead>
                <tbody>
                    {this.getRowsData()}
                </tbody>
            </table>
        </div>

        return body
    }
}
export default DyanmicTable;